var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "comment",
      class: {
        "comment--deleted": _vm.comment.deleted,
      },
    },
    [
      _c("div", { staticClass: "comment__author author" }, [
        _c(
          "div",
          { staticClass: "author__userpic" },
          [_c("userpic", { attrs: { url: _vm.author.userpic } })],
          1
        ),
        _c("div", { staticClass: "author-data" }, [
          _c("div", { staticClass: "author-data__wrapper" }, [
            _vm.author.link
              ? _c(
                  "a",
                  {
                    staticClass: "author__name",
                    attrs: { href: _vm.author.link, target: "_blank" },
                  },
                  [_vm._v(_vm._s(_vm.author.name))]
                )
              : _c("span", { staticClass: "author__name" }, [
                  _vm._v(_vm._s(_vm.author.name)),
                ]),
            _vm.author.post
              ? _c("span", { staticClass: "author__position" }, [
                  _vm._v(_vm._s(_vm.author.post)),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "comment__content" },
        [
          _vm.comment.deleted
            ? _c("div", [
                _c("span", { staticClass: "deleted-message" }, [
                  _vm._v("Комментарий удален"),
                ]),
                _vm.canRestore
                  ? _c(
                      "button",
                      {
                        staticClass: "comment-action",
                        on: { click: _vm.restore },
                      },
                      [_vm._v("Восстановить")]
                    )
                  : _vm._e(),
              ])
            : [
                _c("div", { staticClass: "comment__text" }, [
                  _vm._v(_vm._s(_vm.comment.message)),
                ]),
                _vm.files.length
                  ? _c(
                      "div",
                      { staticClass: "comment__files" },
                      [
                        _c("files", {
                          attrs: { files: _vm.files, actions: true },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
        ],
        2
      ),
      _c("footer", { staticClass: "comment__footer" }, [
        _c("div", { staticClass: "comment__date" }, [
          _vm._v(_vm._s(_vm.comment.createdAt)),
        ]),
        _vm.canEdit && !_vm.comment.deleted
          ? _c(
              "div",
              { staticClass: "comment__actions" },
              [
                _vm.isCurrentUser
                  ? [
                      _c(
                        "button",
                        {
                          staticClass: "comment-action",
                          on: { click: _vm.edit },
                        },
                        [_vm._v("Редактировать")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "comment-action comment-action--delete",
                          on: { click: _vm.remove },
                        },
                        [_vm._v("Удалить")]
                      ),
                    ]
                  : [
                      _c(
                        "button",
                        {
                          staticClass: "comment-action",
                          on: { click: _vm.reply },
                        },
                        [_vm._v("Ответить")]
                      ),
                    ],
              ],
              2
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }